// Nosh spice levels (Theme A) — a heat scale from mild home-style to fiery.
export const SPICE_LEVELS = [
  { level: 0, name: "Seedha-Saada", en: "No spice", color: "#5E7C57" },
  { level: 1, name: "Halka Phulka", en: "Mild", color: "#C6A24C" },
  { level: 2, name: "Ghar Jaisa", en: "Medium", color: "#E08A2E" },
  { level: 3, name: "Teekha", en: "Hot", color: "#D2662F" },
  { level: 4, name: "Aag Laga Di!", en: "Extreme", color: "#B23A2A" },
];

// Sensible default for a fresh tray item (home-style medium).
export const DEFAULT_SPICE = 2;

export const spiceInfo = (lvl) =>
  SPICE_LEVELS[lvl] ?? SPICE_LEVELS[DEFAULT_SPICE];

// Human-readable label used in summaries, emails, and the admin portal.
export const spiceLabel = (lvl) => {
  if (lvl === null || lvl === undefined) return "—";
  const s = spiceInfo(lvl);
  return `${s.name} · ${s.en}`;
};

export const SPICE_GRADIENT =
  "linear-gradient(90deg,#5E7C57,#C6A24C,#E08A2E,#D2662F,#B23A2A)";
